import React from 'react';
import ReactDOM from 'react-dom/client';

import CustomRouter from './router';

import '../styles/app.scss';

const e = React.createElement;
const domContainer = document.querySelector('#app');
const root = ReactDOM.createRoot(domContainer);
root.render(e(CustomRouter));
